import React from 'react';

const reasons = [
  {
    number: '01',
    problem: 'The demo ran on clean sample data.',
    fix: 'We connect your real data, from tickets to transactions, inside your own cloud.',
  },
  {
    number: '02',
    problem: 'Compliance saw it too late.',
    fix: 'Safety checks are built in from day one, so your compliance team can sign it off.',
  },
  {
    number: '03',
    problem: 'Nobody owned it after launch.',
    fix: 'We run it, watch it and improve it every month, with a report on what it saved.',
  },
];

const WhyAIStalls: React.FC = () => {
  return (
    <section className="section-padding bg-neutral-50">
      <div className="container-max">
        <div className="max-w-2xl mb-16">
          <h2 className="text-4xl md:text-5xl font-semibold text-black leading-[1.05] tracking-[-0.02em] mb-5">
            Why AI projects stall. And how we fix it.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 md:gap-10">
          {reasons.map((r) => (
            <div key={r.number} className="bg-white rounded-2xl p-8 border border-neutral-200">
              <p className="text-xs font-semibold text-neutral-400 tracking-widest mb-6">{r.number}</p>
              <p className="text-neutral-500 text-[0.95rem] leading-relaxed mb-4">
                The problem: {r.problem}
              </p>
              <p className="text-black font-medium leading-relaxed text-[0.95rem]">
                What we do: {r.fix}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyAIStalls;
